import { useState, useEffect } from 'react'
import console_log from '../../../util/consolelog'
import {
  Settingsticketimap,
  GetSettingsticketimap
} from '../../../services/data'
import { toast, ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Loader from '../../../components/loader'
import { useLocation, useParams } from 'react-router-dom'

const SettingsPopup = ({ onclose }) => {
  const [mode, setMode] = useState('notify')
  const [notifyEmail, setNotifyEmail] = useState('')
  const [imapEmail, setImapEmail] = useState('')
  const [appPassword, setAppPassword] = useState('')
  const [imapHost, setImapHost] = useState('')
  const [imapPort, setImapPort] = useState(993)
  const [loading, setLoading] = useState(false)
    const location = useLocation()
    const params = useParams()
    
      // ✅ Extract store_id from URL (params or pathname)
      const getStoreIdFromUrl = () => {
        if (params?.store_id) return params.store_id
        const pathParts = location.pathname.split('/')
        console.log(pathParts[1])
        return pathParts[1] || null
      }
    
      const storeid = getStoreIdFromUrl()

  const store_id = storeid ?? ''

  const fetchSettings = async () => {
    const res = await GetSettingsticketimap(store_id)
    if (res.success && res.data) {
      const { type, imap_user, imap_password, imap_host, imap_port } = res.data
      setMode(type === 'imap' ? 'imap' : 'notify')
      if (type === 'imap') {
        setImapEmail(imap_user ?? '')
        // setAppPassword(imap_password ?? '')
        setImapHost(imap_host ?? '')
        setImapPort(imap_port ?? 993)
      } else {
        setNotifyEmail(imap_user ?? '')
      }
    }
  }

  useEffect(() => {
    fetchSettings()
  }, [store_id])

  const handleSave = async () => {
    const selectedEmail = mode === 'imap' ? imapEmail : notifyEmail
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    if (!emailRegex.test(selectedEmail)) {
      toast.error('Please enter a valid email address.', {
        position: 'bottom-center'
      })
      return
    }

    setLoading(true)

    const payload =
      mode === 'notify'
        ? {
            store_id,
            type: 'notify_only',
            imap_host: '',
            imap_port: 0,
            imap_user: selectedEmail,
            imap_password: '',
            meta: {}
          }
        : {
            store_id,
            type: 'imap',
            imap_host: imapHost,
            imap_user: selectedEmail,
            imap_port: Number(imapPort),
            imap_password: appPassword,
            meta: {}
          }

    const res = await Settingsticketimap(payload)
    setLoading(false)

    if (res.success) {
      toast.success(res.message, {
        position: 'bottom-center',
        onClose: () => onclose()
      })
      fetchSettings()
    }
  }

  return (
    <div className='fixed inset-0 bg-black bg-opacity-25 flex justify-center items-center z-50'>
      <div className='bg-[#FFFFFF] shadow-lg w-full max-w-[900px] mx-auto my-[30px] rounded-[24px] border-[1.6px] border-white overflow-y-auto min-h-[40%] max-h-[90%] scrollbar-hide'>
        {/* Header */}
        <div className='sticky top-0 bg-white z-10 flex justify-between items-center px-7 py-4 border-b mb-6'>
          <h1 className='font-extrabold text-[25px]'>Settings</h1>
          <button
            onClick={onclose}
            className='w-[30px] sm:w-[40px] h-[30px] sm:h-[40px] text-[14px] sm:text-[18px] cursor-pointer'
          >
            <svg
              width='30'
              height='30'
              viewBox='0 0 30 30'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M9.1 7.77a.9.9 0 0 0-1.27 1.33L13.67 15l-5.84 5.9a.9.9 0 1 0 1.27 1.27L15 16.33l5.9 5.84a.9.9 0 0 0 1.27-1.27L16.33 15l5.84-5.9a.9.9 0 0 0-1.27-1.27L15 13.67 9.1 7.77z'
                fill='#373737'
              />
            </svg>
          </button>
        </div>

        {/* Mode Selection */}
        <div className='mb-8 px-7'>
          <h2 className='font-semibold text-[16.5px] text-[#252C32] mb-1'>
            Email Configuration for Ticket Management
          </h2>
          <p className='text-sm text-[#252C32] mb-4'>
            Choose how you'd like to handle email communication for tickets:
            send-only notifications or full email syncing via IMAP.
          </p>

          <div className='flex flex-col gap-4'>
            <label className='flex items-start gap-3 cursor-pointer'>
              <input
                type='radio'
                name='emailMode'
                value='notify'
                checked={mode === 'notify'}
                onChange={() => setMode('notify')}
                className='mt-1'
              />
              <div>
                <p className='font-semibold text-[14.5px]'>Notify Only</p>
                <p className='text-sm text-[#252C32]'>
                  Only send outgoing ticket notifications. Incoming replies will
                  not be tracked.
                </p>
              </div>
            </label>

            <label className='flex items-start gap-3 cursor-pointer'>
              <input
                type='radio'
                name='emailMode'
                value='imap'
                checked={mode === 'imap'}
                onChange={() => setMode('imap')}
                className='mt-1'
              />
              <div>
                <p className='font-semibold text-[14.5px]'>
                  IMAP Sync (Recommended)
                </p>
                <p className='text-sm text-[#252C32]'>
                  Send and receive ticket-related emails. Incoming emails will
                  be automatically saved into ticket detail.
                </p>
              </div>
            </label>
          </div>
        </div>

        {/* IMAP Fields */}
        {mode === 'imap' && (
          <div className='mb-8 px-7'>
            <div className='flex flex-col gap-4'>
              <div className='flex flex-col'>
                <label className='font-medium'>Email Address</label>
                <input
                  type='email'
                  placeholder='e.g. support@yourdomain.com'
                  value={imapEmail}
                  onChange={e => setImapEmail(e.target.value)}
                  className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[38px] rounded-[14px] focus:outline-none pl-4 text-[12px] placeholder:text-[12px]'
                />
              </div>

              <div className='flex flex-col'>
                <label className='font-medium'>App Password</label>
                <input
                  type='password'
                  placeholder='App-specific password'
                  value={appPassword}
                  onChange={e => setAppPassword(e.target.value)}
                  autoComplete='new-password'
                  className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[38px] rounded-[14px] focus:outline-none pl-4 text-[12px] placeholder:text-[12px] overflow-hidden text-ellipsis whitespace-nowrap'
                />
              </div>

              <div className='flex flex-col'>
                <label className='font-medium'>IMAP Server</label>
                <input
                  type='text'
                  placeholder='e.g. imap.gmail.com'
                  value={imapHost}
                  onChange={e => setImapHost(e.target.value)}
                  className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[38px] rounded-[14px] focus:outline-none pl-4 text-[12px] placeholder:text-[12px]'
                />
              </div>

              <div className='flex flex-col'>
                <label className='font-medium'>Port</label>
                <input
                  type='number'
                  placeholder='993'
                  value={imapPort}
                  onChange={e => setImapPort(e.target.value)}
                  className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[38px] rounded-[14px] focus:outline-none pl-4 text-[12px] placeholder:text-[12px]'
                />
              </div>
            </div>
          </div>
        )}

        {/* Notify-only Field */}
        {mode === 'notify' && (
          <div className='mb-4 px-7'>
            <div className='flex flex-col'>
              <label className='font-medium'>Email Address</label>
              <input
                type='email'
                placeholder='e.g. support@yourdomain.com'
                value={notifyEmail}
                onChange={e => setNotifyEmail(e.target.value)}
                className='w-[258px] mt-1 border-[#D1D1D1] border-[1px] h-[38px] rounded-[14px] focus:outline-none pl-4 text-[12px] placeholder:text-[12px]'
              />
              <p className='text-xs text-[#252C32] mt-1'>
                Enter the email you want to use for Receiver Notification
              </p>
            </div>
          </div>
        )}

        {/* Submit */}
        <div className='sticky bottom-0 bg-white px-7 py-4 border-t flex justify-end'>
          <button
            onClick={handleSave}
            disabled={loading}
            className={`w-[85px] h-[39px] rounded-[59px] text-white text-[14px] ${
              loading ? 'bg-gray-500 cursor-not-allowed' : 'bg-[#232328]'
            }`}
          >
            {loading ? (
              <div className='flex justify-center items-center'>
                <Loader />
              </div>
            ) : (
              'Save'
            )}
          </button>
        </div>
      </div>
      <ToastContainer />
    </div>
  )
}

export default SettingsPopup
